export interface TagsProps {
  changeToTagsUrl?: () => void;
  tagId?: string;
}

export type TagSortOrder = "asc" | "desc";

export const TAGS_SORT_PARAM = "order";

export const parseSortOrder = (search: string): TagSortOrder =>
  new URLSearchParams(search).get(TAGS_SORT_PARAM) === "desc" ? "desc" : "asc";

export const buildSortOrderSearch = (
  search: string,
  order: TagSortOrder,
): string => {
  const params = new URLSearchParams(search);

  if (order === "asc") {
    params.delete(TAGS_SORT_PARAM);
  } else {
    params.set(TAGS_SORT_PARAM, order);
  }

  const query = params.toString();

  return query ? `?${query}` : "";
};
